module.exports = __webpack_public_path__ + "static/img/ic_kuang.8a7d173.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/function/ic_kuang.png
// module id = 1I04
// module chunks = 1